import { Reveal } from "@/components/Reveal";
import { PRINCIPLES } from "@/content";

const Approach = () => (
  <section data-testid="approach-section" className="border-t border-stone/60">
    <div className="mx-auto max-w-6xl px-6 md:px-10 py-28 md:py-40">
      <div className="max-w-2xl">
        <Reveal>
          <p className="eyebrow mb-6">The REGULATE Approach</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.1]" data-testid="approach-headline">
            Healing isn’t about fixing yourself.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-taupe">
            It’s about understanding what your system learned to do to keep you
            safe.
          </p>
        </Reveal>
      </div>

      <div className="mt-20 md:mt-28" data-testid="approach-principles">
        {PRINCIPLES.map((p, i) => (
          <Reveal key={p.number} delay={0.08 * i} y={20}>
            <div className="group grid md:grid-cols-12 gap-3 md:gap-6 items-baseline border-t border-stone/80 py-10 md:py-14 transition-colors duration-700 hover:bg-cream/50">
              <span className="md:col-span-2 font-serif italic text-3xl md:text-4xl text-teal/90">
                {p.number}
              </span>
              <h3 className="md:col-span-4 font-sans text-sm md:text-base uppercase tracking-[0.35em] text-charcoal">
                {p.title}
              </h3>
              <p className="md:col-span-6 font-serif text-xl md:text-2xl text-taupe leading-snug group-hover:text-charcoal transition-colors duration-700">
                {p.text}
              </p>
            </div>
          </Reveal>
        ))}
        <div className="border-t border-stone/80" aria-hidden="true" />
      </div>
    </div>
  </section>
);

export default Approach;
